import React from 'react'

export default function ApplicationStatusSkeleton() {
  return (
    <div className='placeholder-glow'>
        <span className="placeholder col-12 bg-secondary"></span>
        <span className="placeholder col-12 bg-secondary"></span>
        <span className="placeholder col-12 bg-secondary"></span>
        <span className="placeholder col-12 bg-secondary"></span>
    </div>
  )
}
